// extracted by mini-css-extract-plugin
module.exports = {"first":"Chart2_first__28FR5","second":"Chart2_second__Bds6q","third":"Chart2_third__2id3p","four":"Chart2_four__ckuCY","five":"Chart2_five__2aySQ","six":"Chart2_six__1e4wH"};